class IntroStep {
    title: string;
    text: string;
    element: string;
    extraElement?: string;
    width: number;
    before?: Function;
    after?: Function;
    position?: DevExpress.common.Position;
    
    constructor(title: string, text: string, element: string, extraElement?: string, width?: number, position?: DevExpress.common.Position, before?: Function, after?: Function) {
        this.title = title;
        this.text = text;
        this.element = element;
        this.extraElement = extraElement;
        this.width = width;
        this.position = position;
        this.before = before;
        this.after = after;
    }
}